import Section from '../../../elements/Section'
import Container from '../../../elements/Container'
import Columns from '../../../layout/Columns'
import Column from '../../../layout/Column'
import styles from './styles.module.scss'
import { useResponsive } from '../../../../providers/ResponsiveContext'
import LazyImage from '../../../elements/LazyImage'
import { getS3Url } from '../../../helpers/getS3Url'

const Services = ({ services }) => {
  const { isSmallMobile } = useResponsive()

  if (services) {
    return (
      <Section variant={['white', 'pb0', 'pt0']}>
        <Container variant={['-xs']}>
          {services.map((item, index) => (
            <div key={`service-${index}`} className={styles.service}>
              <Columns
                variant={[
                  index % 2 !== 0 && 'reversed',
                  '-align-middle',
                  '-distribute-between'
                ]}
              >
                <Column spans={isSmallMobile ? 12 : 5}>
                  <div className={styles.service__image}>
                    <LazyImage
                      alt={`Image ${item.title}`}
                      layout="fill"
                      objectFit="cover"
                      objectPosition="50%"
                      src={getS3Url(
                        item.cloudflare_picture || item.picture,
                        '960'
                      )}
                    />
                  </div>
                </Column>

                <Column spans={isSmallMobile ? 12 : 6}>
                  <h2 className={styles.service__title}>{item.title}</h2>

                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.description
                    }}
                    className={styles.service__description}
                  ></div>
                </Column>
              </Columns>
            </div>
          ))}
        </Container>
      </Section>
    )
  }

  return
}

export default Services
